
  import {
    Vue,
    Component,
    Watch
  } from 'vue-property-decorator';

  @Component({
    name: 'app-main'
  })
  export default class AppMain extends Vue {
    
  }
